export const validEmail = (email) => email?.includes('@');
export const validPassword = (password) => password?.length >= 8;
export const validPasswordConfirmation = (password, passwordConfirmation) => password === passwordConfirmation;
export const validPhoneNumber = (phoneNumber) => phoneNumber?.replace(/\D/g, '').length === 10;
export const validName = (name) => name?.length >= 3;
export const validCost = (cost) => cost >= 0;
